// extracted by mini-css-extract-plugin
export default {"modalStringContent":"styles_modalStringContent__O4ezq","buttonDelete":"styles_buttonDelete__ktdkj","icon":"styles_icon__IIib+","fileName":"styles_fileName__CIRpJ"};